import { currencyFormat } from 'common/helpers/numberHelper';

const ModifierPrice = (props) => {
  const { item, settings } = props;

  const { modifiers } = item;

  if (!modifiers) return null;

  const { options } = modifiers;

  let totalModifierPrice = 0;

  if (modifiers) {
    Object.keys(options).forEach((slug) => {
      options[slug].forEach((option) => {
        totalModifierPrice += option.price;
      });
    });
  }

  if (!totalModifierPrice) {
    return null;
  }

  return <>+{currencyFormat(totalModifierPrice, settings)}</>;
};

export default ModifierPrice;
